import middlewareConfig from "./middleware-config";
import { MIDDLEWARE_ENUMS } from "./middleware-constants";

const vasBffService = (api) => {

    const getPdiData = () => {
        return api.get("/api/v1/PDI/HOME_PAGE");
    };

    const getPdiCityData = (city) => {
        return api.get(`/api/v1/PDI/CITY_PAGES?slug=${city}`);
    };

    return {
        getPdiData,
        getPdiCityData
    };
};

export const VasBffService = vasBffService(middlewareConfig(MIDDLEWARE_ENUMS.VAS_BFF_SERVICE));
